const PopulationGroupBoilerplate = {
    data() {
        return {
            dataArray: [],
            hydrated: false,
            fieldTypes: ['text', 'textarea'],
        };
    },

    methods: {
        loadFieldData() {
            if (this.population && this.population.data) {
                this.population.data.forEach((pop, index) => {
                    this.dataArray[index] = this.population.data[index];
                });
            }

            this.hydrated = true;

            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                data: this.dataArray,
            };

            this.storeFieldData();
        }
    }
};

export default PopulationGroupBoilerplate;
